import { render, staticRenderFns } from "./NewConfirmPopup.vue?vue&type=template&id=66af23f0&scoped=true&lang=pug"
import script from "./NewConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./NewConfirmPopup.vue?vue&type=script&lang=ts"
import style0 from "./NewConfirmPopup.vue?vue&type=style&index=0&id=66af23f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af23f0",
  null
  
)

export default component.exports